import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {TrackingStreamSectionContext} from '@aboutyou/legacy-tracking-sdk';
import {useTrackDetailPage} from '../trackingHooks/trackDetailPage';
import {Brand, Product} from '../utils/types';

export const DetailPageTracker = (props: {
  product: Product;
  price?: Price;
  brand: Brand;
  pageTitle: string;
  shouldTrackViewItemEvent: boolean;
  section?: TrackingStreamSectionContext['recoType'];
  badgesList?: string[];
}) => {
  const {
    product,
    price,
    brand,
    pageTitle,
    shouldTrackViewItemEvent,
    section,
    badgesList,
  } = props;
  useTrackDetailPage({
    product,
    price,
    brand,
    pageTitle,
    section,
    shouldTrackViewItemEvent,
    badgesList,
  });

  return null;
};
